// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performance-table-container {
    background: #fff7f0; /* light orange background */
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  .performance-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .performance-table th,
  .performance-table td {
    padding: 12px;
    text-align: left;
    /* border-bottom: 1px solid #ffe0c7; */
  }
  
  .rm-row {
    cursor: pointer;
    background-color: #fff3e6;
    font-weight: bold;
  }
  
  .rm-row.open {
    background-color: #ffe9d6;
  }
  
  .mr-row {
    background-color: #ffffff;
  }
  
  .role-badge {
    background: #ffa94d;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
  
  .mr-badge {
    background: #ff7b00;
  }
  

  
  .total-cell {
    font-weight: bold;
    color: #ff7b00;
  }
  
  .action-btn {
    color: #ff7b00;
    font-weight: bold;
    cursor: pointer;
  }
  
  .arrow {
    display: inline-block;
    margin-right: 8px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid orange; /* Orange arrow */
    transition: transform 0.2s ease-in-out;
  }
  
  .arrow.down {
    transform: rotate(90deg);
  }`, "",{"version":3,"sources":["webpack://./src/components/performance-table/performance-table.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB,EAAE,4BAA4B;IACjD,aAAa;IACb,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;;;EAIA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,6BAA6B,EAAE,iBAAiB;IAChD,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;EAC1B","sourcesContent":[".performance-table-container {\n    background: #fff7f0; /* light orange background */\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .performance-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .performance-table th,\n  .performance-table td {\n    padding: 12px;\n    text-align: left;\n    /* border-bottom: 1px solid #ffe0c7; */\n  }\n  \n  .rm-row {\n    cursor: pointer;\n    background-color: #fff3e6;\n    font-weight: bold;\n  }\n  \n  .rm-row.open {\n    background-color: #ffe9d6;\n  }\n  \n  .mr-row {\n    background-color: #ffffff;\n  }\n  \n  .role-badge {\n    background: #ffa94d;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n  }\n  \n  .mr-badge {\n    background: #ff7b00;\n  }\n  \n\n  \n  .total-cell {\n    font-weight: bold;\n    color: #ff7b00;\n  }\n  \n  .action-btn {\n    color: #ff7b00;\n    font-weight: bold;\n    cursor: pointer;\n  }\n  \n  .arrow {\n    display: inline-block;\n    margin-right: 8px;\n    width: 0;\n    height: 0;\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid orange; /* Orange arrow */\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .arrow.down {\n    transform: rotate(90deg);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
